import { useClient } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'
import { useToast } from './useToast'

/**
 * Shared post action utilities (delete + copy-link) used by both the global
 * discussions page and entity-level thread views. Encapsulates client calls
 * and toast notifications so the logic is not duplicated.
 */
export const usePostActions = () => {
  const client = useClient()
  const t = useTranslations().app.discussions
  const { showSuccessToast, showFailToast } = useToast()

  const copyLink = (postId: number, url?: string) => {
    const link = url ?? `${window.location.origin}/prikbord?post=${postId}`
    void navigator.clipboard
      .writeText(link)
      .then(() => showSuccessToast(t.linkCopied))
      .catch(() => showFailToast())
  }

  const deletePost = async (postId: number): Promise<boolean> => {
    try {
      await client.call('delete-post', { id: postId })
      showSuccessToast(t.deleteSuccess)
      return true
    } catch {
      showFailToast()
      return false
    }
  }

  return { copyLink, deletePost }
}
